import * as React from 'react';
import Tooltip from '@mui/material/Tooltip';

import './index.scss';

function Navigation({
  title = '',
  leftSectionComponent: LeftSectionComponent,
  rightSectionComponent: RightSectionComponent,
}) {
  const titleRef = React.useRef(null);
  const [isOverflowing, setIsOverflowing] = React.useState(false);

  React.useEffect(() => {
    if (titleRef.current) {
      setIsOverflowing(titleRef.current.scrollWidth > titleRef.current.clientWidth);
    }
  }, [title]);

  return (
    <div className="navigation">
      <div className="left">
        <LeftSectionComponent />
      </div>
      <div className="center">
        {isOverflowing ? (
          <Tooltip title={title} arrow>
            <h1 ref={titleRef} className="title">{ title }</h1>
          </Tooltip>
        ) : (
          <h1 ref={titleRef} className="title">{ title }</h1>
        )}
      </div>
      <div className="right">
        <RightSectionComponent />
      </div>
    </div>
  );
}

export default Navigation;
